<script setup>
const props = defineProps({
  holder: {
    type: Object,
    required: true,
  },
});

const userAvatarRef = ref(null);

const openProfileDialog = () => {
  userAvatarRef.value.openProfileDialog();
};
</script>

<template>
  <v-list-item class="tw-cursor-pointer" @click="openProfileDialog">
    <template v-slot:prepend>
      <user-avatar
        ref="userAvatarRef"
        :imageUrl="holder?.photoUrl"
        :userOrId="holder.id"
        class="tw-w-full"
      />
    </template>

    <v-list-item-title>
      {{ holder?.displayName }}
    </v-list-item-title>

    <template v-slot:append>
      <v-list-item-action class="!tw-font-bold">
        {{ holder.balance }}
      </v-list-item-action>
    </template>
  </v-list-item>
</template>
